<template lang="pug">
  .mb-3
    label.form-label {{label}}
    input.form-control(:class="classmethod" :type='type' :name='name' :placeholder='placeholder' :value="value" :required="required?true:false" @input="$emit('input', $event.target.value)")
    form_error(:errors="errors?errors[name]:[]")
</template>

<script>
import formError from './formErrors';
import { mapState } from 'vuex';
export default {
  components: {
    form_error: formError,
  },
  props:[
    'label', 'type', 'name', 'placeholder', 'value', 'required', 'inputclass'
  ],
  computed:{
    classmethod(){
      var errorclass = this.errors?this.errors[name]?'is-invalid':'':'';
      return errorclass + ' ' + this.inputclass;
    },
    ...mapState('api', ['errors'])
  }
}
</script>